// @Version: 1.0.0
import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { COLOR, IFieldItem, POSITION } from '../field-item.model';
import { FieldItemService } from '../field-item.service';

@Component({
   selector: 'app-field-item-title-second',
   templateUrl: './title-second.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => FieldItemTitleSecondComponent)
      }
   ],
   standalone: false
})

export class FieldItemTitleSecondComponent implements ControlValueAccessor, OnDestroy {

   public COLOR = COLOR;
   public POSITION = POSITION;

   private fieldItem_: IFieldItem = {} as IFieldItem;

   @Input() 
   set fieldItem (value: IFieldItem) {
      this.fieldItem_ = value || {};
   }
   get fieldItem (): IFieldItem {
     return this.fieldItem_;
   }

   constructor (public sFieldItem: FieldItemService) {}
   
   ngOnDestroy (): void {
      this.fieldItem_ = {} as IFieldItem;
   }

   writeValue (obj: any): void {}
   registerOnChange (fn: any): void {}
   registerOnTouched (fn: any): void {}
   setDisabledState (isDisabled: boolean | undefined): void {}
}